import { TournamentProvider } from "./TournamentContext";
import Tournament from "./Tournament";

const TournamentIndex = () => {
  return (
    <TournamentProvider>        
      <Tournament />
    </TournamentProvider>
  );
};
export default TournamentIndex;
